import { useLocation } from 'react-router'
import { useWindowSize } from 'src/components/app/utils/hooks/useWindowSize'
import { MainNav } from 'src/components/parts/navigation/MainNav'
import * as breakpoints from 'src/constants/breakpoints'

function Navigation() {
    const { pathname } = useLocation()
    const windowSize = useWindowSize()

    return <MainNav activeLink={pathname} isMobile={windowSize.width <= breakpoints.pixels.mobile} />
}

export default Navigation
